module.exports = __webpack_public_path__ + "images/emoji/boot.aeb749b78ea0cb1e88fd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/boot.png
// module id = 7l+a
// module chunks = 13